<template>
  <div id="add-event-image">
    <v-card class="dialog-card" elevation="12">
      <!-- Premium Header -->
      <div class="header-section">
        <div class="header-gradient"></div>
        <div class="header-backdrop"></div>
        <div class="header-content">
          <div class="header-left">
            <div class="header-icon-box">
              <v-icon large color="white">mdi-account-plus</v-icon>
            </div>
            <div class="header-text">
              <h1 class="header-title">{{ pageTitle }}</h1>
              <p class="header-subtitle">Add participant information</p>
            </div>
          </div>
          <div class="header-right">
            <v-btn
              icon
              large
              color="white"
              class="close-btn"
              @click="closePrompt"
              title="Close"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <v-sheet class="form-sheet overflow-y-auto" max-height="600">
        <v-container class="pt-6">
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="submitData"
          >
            <v-card-text class="px-0">
              <!-- Personal Information Section -->
              <div class="form-section-title mb-4">
                <v-icon small color="primary" class="mr-2">mdi-information-outline</v-icon>
                <span>Personal Information</span>
              </div>

              <v-row wrap class="form-fields-grid">
                <!-- Participant Name -->
                <v-col cols="12" sm="6" md="6">
                  <div class="field-wrapper">
                    <label class="field-label">
                      <v-icon x-small color="primary" class="mr-1">mdi-account</v-icon>
                      <span class="text-danger">*</span> Participant Name
                    </label>
                    <v-text-field
                      v-model="ParticipantName"
                      :rules="ParticipantNameRules"
                      placeholder="Enter participant name"
                      outlined
                      dense
                      rounded
                      class="form-control"
                      prepend-inner-icon="mdi-pencil"
                    ></v-text-field>
                  </div>
                </v-col>

                <!-- Gender -->
                <v-col cols="12" sm="6" md="3">
                  <div class="field-wrapper">
                    <label class="field-label">
                      <v-icon x-small color="primary" class="mr-1">mdi-gender-male-female</v-icon>
                      <span class="text-danger">*</span> Gender
                    </label>
                    <v-select
                      v-model="Gender"
                      :items="GenderOptions"
                      :rules="GenderRules"
                      :reduce="(option) => option.value"
                      outlined
                      dense
                      rounded
                      class="form-control"
                    ></v-select>
                  </div>
                </v-col>

                <!-- Age -->
                <v-col cols="12" sm="6" md="3">
                  <div class="field-wrapper">
                    <label class="field-label">
                      <v-icon x-small color="primary" class="mr-1">mdi-calendar</v-icon>
                      <span class="text-danger">*</span> Age
                    </label>
                    <v-text-field
                      v-model="Age"
                      :rules="AgeRules"
                      placeholder="Age"
                      v-mask="'##'"
                      outlined
                      dense
                      rounded
                      type="number"
                      class="form-control"
                      prepend-inner-icon="mdi-pound"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>

              <!-- Contact Information Section -->
              <div class="form-section-title mb-4 mt-6">
                <v-icon small color="primary" class="mr-2">mdi-phone-in-talk</v-icon>
                <span>Contact Information</span>
              </div>

              <v-row wrap class="form-fields-grid">
                <!-- Email ID -->
                <v-col cols="12" sm="6">
                  <div class="field-wrapper">
                    <label class="field-label">
                      <v-icon x-small color="primary" class="mr-1">mdi-email</v-icon>
                      <span class="text-danger">*</span> Email ID
                    </label>
                    <v-text-field
                      v-model="EmailId"
                      :rules="EmailIdRules"
                      placeholder="Enter email address"
                      outlined
                      dense
                      rounded
                      type="email"
                      class="form-control"
                      prepend-inner-icon="mdi-at"
                    ></v-text-field>
                  </div>
                </v-col>

                <!-- Mobile Number -->
                <v-col cols="12" sm="6">
                  <div class="field-wrapper">
                    <label class="field-label">
                      <v-icon x-small color="primary" class="mr-1">mdi-phone</v-icon>
                      <span class="text-danger">*</span> Mobile Number
                    </label>
                    <v-text-field
                      v-model="MobileNumber"
                      :rules="MobileNumberRules"
                      :counter="10"
                      v-mask="'##########'"
                      placeholder="10-digit number"
                      outlined
                      dense
                      rounded
                      class="form-control"
                      prepend-inner-icon="mdi-phone"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>

              <!-- Preferences Section -->
              <div class="form-section-title mb-4 mt-6">
                <v-icon small color="primary" class="mr-2">mdi-food</v-icon>
                <span>Preferences</span>
              </div>

              <v-row wrap class="form-fields-grid">
                <!-- Food Preference -->
                <v-col cols="12">
                  <div class="field-wrapper">
                    <label class="field-label">
                      <v-icon x-small color="primary" class="mr-1">mdi-silverware-fork-knife</v-icon>
                      <span class="text-danger">*</span> Food Preference
                    </label>
                    <v-select
                      v-model="FoodPreference"
                      :items="FoodPreferenceOptions"
                      :rules="FoodPreferenceRules"
                      :reduce="(option) => option.value"
                      outlined
                      dense
                      rounded
                      class="form-control"
                    ></v-select>
                  </div>
                </v-col>
              </v-row>

              <!-- Action Buttons -->
              <v-row wrap class="action-buttons-section mt-8">
                <v-col align="center" cols="12">
                  <v-btn
                    @click="closePrompt"
                    elevation="6"
                    rounded
                    large
                    class="action-btn cancel-btn"
                  >
                    <v-icon left>mdi-close-circle</v-icon>
                    Cancel
                  </v-btn>
                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="submitData"
                    :loading="SubmitFlag"
                    elevation="6"
                    rounded
                    large
                    class="action-btn submit-btn"
                  >
                    <v-icon left>mdi-check-circle</v-icon>
                    Add Participant
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-container>
      </v-sheet>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,

      LoadingFlag: false,
      SubmitFlag: false,

      ParticipantName: "",
      ParticipantNameRules: [(v) => !!v || "Participant name is required"],

      Gender: "",
      GenderRules: [(v) => !!v || "Gender is required"],
      GenderOptions: [
        { value: "", text: "--Select--" },
        { value: "Male", text: "Male" },
        { value: "Female", text: "Female" },
        { value: "Others", text: "Others" },
      ],

      FoodPreference: "",
      FoodPreferenceRules: [(v) => !!v || "Food preference is required"],
      FoodPreferenceOptions: [
        { value: "", text: "--Select--" },
        { value: "Veg", text: "Veg" },
        { value: "Non Veg", text: "Non Veg" },
      ],

      Age: "",
      AgeRules: [(v) => !!v || "Age is required"],

      MobileNumber: "",
      MobileNumberRules: [(v) => !!v || "Mobile number is required"],

      EmailId: "",
      EmailIdRules: [
        (v) => !!v || "E-mail ID is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail ID must be valid",
      ],

      Member: {},
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.closePrompt();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt(Member = {}) {
      console.log("closePrompt called");
      console.log({ Member });
      this.$emit("hideDialog", Member);
    },
    refreshPageData() {
      console.log("refreshPageData called");
    },
    submitData() {
      console.log("submitData is called");
      var message = "";
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        var tempData = {
          MemberFlag: true,
          ParticipantName: this.ParticipantName,
          Gender: this.Gender,
          Age: this.Age,
          MobileNo: this.MobileNumber,
          EmailId: this.EmailId,
          Food: this.FoodPreference,
          action: "",
        };
        console.log({ tempData });
        this.closePrompt(tempData);
      } else {
        if (validate1 == false) {
          message += "Kindly fill the required fields. ";
        }
        this.toast("error", message, true);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
// Color Palette
$primary-color: #667eea;
$secondary-color: #764ba2;
$gradient-main: linear-gradient(135deg, $primary-color 0%, $secondary-color 100%);
$success-color: #10b981;
$warning-color: #f59e0b;
$danger-color: #f44336;
$text-primary: #1a202c;
$text-secondary: #555;
$border-color: #e2e8f0;
$bg-light: #f7f9fc;

// Animation Keyframes
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#add-event-image {
  // ============================================
  // DIALOG CARD
  // ============================================
  .dialog-card {
    border-radius: 16px !important;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(102, 126, 234, 0.3) !important;
    border: none;
  }

  // ============================================
  // HEADER SECTION
  // ============================================
  .header-section {
    background: $gradient-main;
    position: relative;
    overflow: hidden;
    padding: 24px;
    animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);

    .header-gradient {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: $gradient-main;
      opacity: 1;
    }

    .header-backdrop {
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      animation: rotate 20s linear infinite;
    }

    .header-content {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 20px;
    }

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;
      flex: 1;
    }

    .header-icon-box {
      background: rgba(255, 255, 255, 0.2);
      backdrop-filter: blur(10px);
      border-radius: 12px;
      padding: 10px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
      animation: float 3s ease-in-out infinite;
      flex-shrink: 0;
    }

    .header-text {
      flex: 1;

      .header-title {
        font-size: 22px;
        font-weight: 800;
        color: white;
        margin: 0;
        letter-spacing: 0.5px;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
      }

      .header-subtitle {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.9);
        margin: 4px 0 0 0;
        letter-spacing: 0.3px;
      }
    }

    .header-right {
      flex-shrink: 0;
    }

    .close-btn {
      transition: all 0.3s ease;
      background: rgba(255, 255, 255, 0.15) !important;
      backdrop-filter: blur(10px);
      border: 2px solid rgba(255, 255, 255, 0.3);

      &:hover {
        background: rgba(255, 255, 255, 0.25) !important;
        transform: rotate(90deg);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
      }
    }
  }

  // ============================================
  // FORM SHEET
  // ============================================
  .form-sheet {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  }

  // ============================================
  // FORM SECTIONS
  // ============================================
  .form-section-title {
    font-size: 14px;
    font-weight: 700;
    color: $text-primary;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    display: flex;
    align-items: center;
    padding: 12px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
    border-left: 4px solid $primary-color;
    border-radius: 4px;
  }

  // ============================================
  // FORM FIELDS
  // ============================================
  .form-fields-grid {
    animation: slideInUp 0.6s ease-out;
  }

  .field-wrapper {
    animation: slideInUp 0.6s ease-out;
  }

  .field-label {
    font-size: 12px;
    font-weight: 700;
    color: $text-primary;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    opacity: 0.85;

    .v-icon {
      flex-shrink: 0;
    }

    .text-danger {
      color: $danger-color;
      margin: 0 4px;
    }
  }

  .form-control {
    ::v-deep {
      .v-input__slot {
        border-radius: 8px !important;
      }

      .v-text-field--outlined,
      .v-select--is-menu-active {
        fieldset {
          border-color: $border-color;
          transition: all 0.3s ease;
        }
      }

      .v-input {
        &:hover {
          fieldset {
            border-color: $primary-color;
          }
        }
      }

      .v-input--is-focused {
        fieldset {
          border-color: $primary-color !important;
        }
      }
    }
  }

  // ============================================
  // ACTION BUTTONS
  // ============================================
  .action-buttons-section {
    display: flex;
    gap: 12px;
    justify-content: center;
    padding-top: 24px;
    border-top: 2px solid $border-color;

    .action-btn {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      font-weight: 700;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
      min-width: 150px;

      &.cancel-btn {
        background: linear-gradient(135deg, $danger-color 0%, #d32f2f 100%) !important;
        color: white !important;

        &:hover:not(:disabled) {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(244, 67, 54, 0.4) !important;
        }
      }

      &.submit-btn {
        background: linear-gradient(135deg, $success-color 0%, #059669 100%) !important;
        color: white !important;

        &:hover:not(:disabled) {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(16, 185, 129, 0.4) !important;
        }
      }

      .v-icon {
        margin-right: 8px;
      }
    }
  }

  // ============================================
  // TEXT UTILITY
  // ============================================
  .text-danger {
    color: $danger-color;
    font-weight: 700;
  }
}
</style>
